import type { RouteObject } from 'react-router';

import type { RouteHandle } from '@/hooks/useRouteHandle';

import type { LegalPageDoc, LegalRouteHandle } from './types';

const legal = () => import('./pages/LegalPage').then((m) => ({ Component: m.LegalPage }));

/** 법무 라우트 1건 — LegalPage 하나를 handle.docId 로 공유(title 은 문서 타이틀 자동 반영). */
function legalRoute(path: string, title: string, docId: LegalPageDoc): RouteObject {
  const handle: RouteHandle & LegalRouteHandle = { title, docId };
  return { path, lazy: legal, handle };
}

export const legalRoutes: RouteObject[] = [
  legalRoute('legal/terms', '이용약관', 'terms'),
  legalRoute('legal/refund', '환불규정', 'refund'),
  legalRoute('legal/privacy', '개인정보처리방침', 'privacy'),
  legalRoute('legal/business', '사업자정보', 'business'),
];
